import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const getTestList = (formData) => {
    return axiosInstance.post(`api/test/list`, formData);
}

export const statusTest = (id) => {
    return axiosInstance.post(`api/test/status?testId=${id}`,{});
}

export const deleteTest = (id) => {
    return axiosInstance.post(`api/test/delete?testId=${id}`,{});
}

export const addTest = (formData) => {
    return axiosInstance.post(`api/test/create`,formData);
}

export const updateTest = (formData) => {
    return axiosInstance.post(`api/test/update`,formData);
}

export const viewTest = (id) => {
    return axiosInstance.post(`api/test/get?testId=${id}`,{});
}

export const masterDepartment = () => {
    return axiosInstance.post(`api/master/department/master-list`,{});
}

export const masterSample = () => {
    return axiosInstance.post(`api/master/sample-type/master`,{});
}

export const masterTest = () => {
    return axiosInstance.post(`api/master/test-method/master `,{});
}

export const masterParameter = () => {
    return axiosInstance.post(`api/parameters/master-list`,{});
}

export const globalTest = () => {
    return axiosInstance.post(`api/global-master/lab_tests_master`,{});
}

export const importGlobalTests = (payload) => {
    return axiosInstance.post(`api/global-master/import_lab_tests_master`, payload);
}

